module.exports = __webpack_public_path__ + "static/img/smartControlCore2.3385ec8d.png";